<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-main">
        <div class="footer-left">
          <img class="footer-logo" src="/img/swiss.png" alt="Swiss Money" title="Swiss Money">
          <h4 class="footer-heading">Contato</h4>
          <a href="https://t.me/SuporteSwissMoney" target="_blank" rel="noopener noreferrer" class="telegram-btn">
            <img src="/img/telegram.png" alt="Telegram" class="telegram-icon">
            TELEGRAM SUPORTE
          </a>
        </div>

        <div class="footer-center">
          <div class="club-swiss-box">
            <img src="/img/club-swiss.jpg" alt="Club Swiss" class="club-swiss-logo">
          </div>
          <p class="footer-description">Comunidade unida: faça parte de um grupo que compartilha experiências e conquistas.</p>
        </div>

        <div class="footer-right">
          <div class="alerta-box">
            <img src="/img/alertanvh-golpe.png" alt="Alerta de Golpe" class="alerta-image">
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="footer-copyright">© 2026 Swiss Money. All rights reserved.</p>
      </div>
    </div>
  </footer>
</template>

<script>

export default {
  name: 'footerComponent'
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables.scss";

.footer {
  background: #000;
  color: #fff;
  padding: 60px 0 30px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-main {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  padding-bottom: 40px;
  border-bottom: 1px solid #333;
}

.footer-left {
  .footer-logo {
    height: 45px;
    width: auto;
    margin-bottom: 25px;
  }

  .footer-heading {
    font-size: 16px;
    font-weight: 600;
    color: #fff;
    margin: 0 0 15px 0;
  }

  .telegram-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 12px 24px;
    background: #0088cc;
    color: #fff;
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    border-radius: 8px;
    transition: opacity 0.3s;

    &:hover {
      opacity: 0.9;
    }

    .telegram-icon {
      height: 24px;
      width: auto;
    }
  }
}

.footer-center {
  .club-swiss-box {
    margin-bottom: 20px;
  }

  .club-swiss-logo {
    max-width: 200px;
    height: auto;
  }

  .footer-description {
    font-size: 15px;
    color: #fff;
    line-height: 1.6;
    margin: 0;
  }
}

.footer-right {
  .alerta-box {
    max-width: 350px;
  }

  .alerta-image {
    width: 100%;
    height: auto;
    display: block;
  }
}

.footer-bottom {
  padding-top: 30px;
  text-align: center;
}

.footer-copyright {
  font-size: 14px;
  color: #888;
  margin: 0;
}

// Desktop
@media screen and (min-width: $desktop-width) {
  .footer-main {
    grid-template-columns: auto 1fr auto;
    align-items: start;
    gap: 60px;
  }
}

// Print
@media print {
  .footer {
    display: none;
  }
}
</style>
